import {NameValueDTO} from './NameValueDTO';

export class DataColumnDTO {
  dataColumnId: number;
  name: string;
  dataColumnType: NameValueDTO;
}

export function CreateDataColumnDTO(dataColumnId: number, name: string, dataColumnType: NameValueDTO): DataColumnDTO {
  const dataColumnDTO = new DataColumnDTO();
  dataColumnDTO.dataColumnId = dataColumnId;
  dataColumnDTO.name = name;
  dataColumnDTO.dataColumnType = dataColumnType;
  return dataColumnDTO;
}
